<template>
  <frontoffice-frame>
    <div class="row profile">
      <b-tabs align="center">
        <b-tab :title="$t('user.my_profil')">
          <div class="user-info-section row justify-content-center">
            <div class="col-lg-5 col-xl-6 user-info">
              <div class="user-informations text-center text-md-left">
                <p>
                <span>
                  {{ formatGender(user.gender) }}
                  {{ user.firstName | capitalise}}
                  {{ user.lastName | uppercase }}
                </span>
                </p>

                <p v-if="user.mobile">
                  <span>{{ formatPhoneNumber(user.mobile) }}</span>
                </p>

                <p>
                  <span>{{ user.email }}</span>
                </p>
              </div>
            </div>
            <!-- <div class="row justify-content-center"> -->
              <div class="col-lg-7 col-xl-6">
                <div class="password-section bg-light">
                  <p class="new-password-title">
                    {{ $t('_modify') }} {{ $t('_password') | lowercase }}
                  </p>
                  <div class="current-password">
                    <span>{{ $t('define_password.current_password') }}</span>

                    <b-form-input id="inputCurrentPassword" type="password"
                                  v-model="currentPassword"
                    />
                  </div>
                  <div class="new-password">
                    <span>{{ $t('define_password.new_password') }}</span>

                    <b-form-input id="inputModifPassword" type="password"
                                  v-model="newPassword"
                    />
                  </div>
                  <div class="confirm-new-password">
                    <span>{{ $t('define_password.confirm_new_password') }}</span>

                    <b-form-input id="inputModifPassword2" type="password"
                                  v-model="confirmNewPassword"
                    />
                  </div>
                  <div class=" text-center send">
                    <button class="orange-white btn" @click="changePassword">
                      {{ $t('_modify') }}
                    </button>
                  </div>
                  <div v-if="errors.password.length || success.password">
                    <div class="col-lg-6 offset-lg-3">
                      <b-alert v-if="errors.password.length" variant="danger" show>
                        <div v-for="error in errors.password" :key="error.id" class="error">
                          {{ error }}
                        </div>
                      </b-alert>

                      <b-alert v-else-if="success.password" variant="success" show dismissible>
                        {{ $t('define_password.alert.success')}}
                      </b-alert>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
            <div class="row justify-content-end">
              <div class="col-md-6 user-config-section">
              <span class="user-config-title">
                {{ $t('_config') }}
              </span>

                <b-form-checkbox id="send-voucher-to-travellers"
                                 name="send-voucher-to-travellers"
                                 v-model="user.sendVoucherToTravellers"
                                 @change="toggleSendVoucherToTravellers"
                >
                  {{ $t('_notifyTravellers') }}
                </b-form-checkbox>
              </div>
            </div>
        </b-tab>

        <b-tab :title="$t('_travel_policy')" v-if="displayTravelPolicy">
          <div class="travel-policy-section row">
            <div class="mode col-12 text-center">
              {{ $t(`travelPolicy.mode.front.${company.travelPolicy.mode}`) }}
            </div>
            <div class="col-12">
              <b-table :items="travelPolicy.items" :fields="travelPolicy.fields"
                       responsive="sm" striped hover :sort-compare="onSortTravelPolicy"
              >
                <template v-for="field in travelPolicy.fields"
                          :slot="`HEAD_${field.key}`" slot-scope="value"
                >
                  <div>
                    {{ field.key === 'room' ? $t('travelPolicy.price.roomSplit.1') : value.label }}
                  </div>

                  <div :style="{ height: '1rem', fontSize: '0.6rem' }">
                    {{ field.key === 'room' ? $t('travelPolicy.price.roomSplit.2') : "" }}
                  </div>
                </template>

                <template slot="sectorType" slot-scope="row">
                  <div v-if="row.value">
                    <div>{{ $t(`sector.type.${row.value}`) }}</div>
                  </div>
                </template>
              </b-table>
            </div>
            <div v-if="company.mealPriceContribution" class="col-12">
            <span class="title">
              {{ $t('booking.meal_contribution') }}
            </span>

              <span class="value">
              {{ $t(company.mealPriceContribution) |currency }}
            </span>
            </div>
          </div>
        </b-tab>

        <b-tab :title="$tc('company.default', 1)">
          <div class="row company-section">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-xl-6 company-info-section">
                  <div class="col-12 company-info bg-light">
                    <div class=" col-12 company-title">
                      <p class="row">
                        <span class="icon"><i class="fas fa-map-marker"></i></span>
                        <span class="ico-title">{{ $t('company.informations.adresse') }}</span>
                      </p>
                    </div>
                    <div class="company-content">
                      <p class="col-12 company-name">{{ company.name }}</p>
                      <p class=" col-12 company-adress">{{ company.address1 }}</p>
                      <p v-if="company.address2" class="company-adress">
                        {{ company.address2 }}
                      </p>
                      <p class="col-12 location">
                        <span class="company-postcode">{{ company.postcode }}</span>
                        <span class="company-city">{{ company.city }}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="col-12 company-logo bg-light">
                    <div class="col-12 company-title">
                      <p class="row">
                        <span class="col-10">
                          {{ $t('company.logoImage.title') }}
                        </span>
                      </p>
                    </div>
                      <!-- <img v-if="company.logo"
                           :src="company.logo"
                           :alt="company.name"
                           :class="[ isMobileAndShown ? '' : 'col-12' ]"
                      />
                      <p v-else class="col-12 no-logo-frame">{{ $t('company.logoImage.noLogoMessage') }} </p> -->
                    <div class="company-logo">
                      <button class="col-3 btn orange-white float-right" v-if="isManager" @click="sendLogo">
                        {{ $t('_send') }}
                      </button>
                      <image-input :image-val="company.logo" :alt="company.name" :allow-modify="isManager" @input="setLogo($event)" v-bind:alone="true" id="tooltip-upload" class="col-9 upload-group"
                      />
                      <div v-if="errors.logo || success.logo">
                        <div class="col-12">
                          <b-alert v-if="errors.logo" variant="danger" show>
                            {{ errors.logo }}
                          </b-alert>

                          <b-alert v-else-if="success.logo" variant="success" show>
                            {{ $t('change_company_logo.alert.success')}}
                          </b-alert>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-12">
              <div class="col-12 company-options-section bg-light">
                <div class="col-12 company-title">
                  <p class="row">
                    <span class="icon"><i class="fas fa-cogs"></i></span>
                    <span class="ico-title">{{ $t('company.informations.options') }}</span>
                  </p>
                </div>

                <div id="validation" class="col-12 validation-section" v-if="isManager">
                  <div class="row">
                    <div class="col-12 col-md-6 section">
                      <p class="row">
                        <span class="col-10 title">
                          {{ $t('company.managerValidation.pre') }}
                        </span>
                        <span class="col-2"><fa-bool :value="company.managerPreVal" /></span>
                      </p>
                    </div>
                    <div class="col-12 col-md-6 section">
                      <p class="row">
                        <span class="col-10 title">
                          {{ $t('company.managerValidation.post') }}
                        </span>
                        <span class="col-2"><fa-bool :value="company.managerPostVal" /></span>
                      </p>
                    </div>
                    <div class="col-12 col-md-6 section">
                      <p class="row">
                        <span class="col-10 title">
                          {{ $t('company.managerValidation.travelPolicyDontSuit') }}
                        </span>
                        <span class="col-2"><fa-bool :value="company.managerPostValPolicyDontSuit" /></span>
                      </p>
                    </div>
                    <div id="exclude-non-free" class="col-12 col-md-6 section" v-if="isManager">
                      <p class="row">
                        <span class="col-10 title">
                          {{ $t('company.excludeOnlineNonFreeCancellation') }}
                        </span>
                        <span class="col-2"><fa-bool :value="company.excludeOnlineNonFreeCancellation || false" /></span>
                      </p>
                    </div>
                  </div>
                  <div id="order-number" class="section" v-if="isManager && company.orderNumber">
                    <div>
                      <span class="title">
                        {{ $t('company.orderNumber.title') }}
                      </span>
                        <fa-bool :value="company.orderNumber.required" />
                    </div>

                    <div v-if="company.orderNumber.required">
                      <span class="title">
                        {{ $t('_order_number_pattern') }}
                      </span>
                      <span class="value">
                        {{ company.orderNumber.pattern || $t('_undefined')}}
                      </span>
                    </div>

                    <div>
                      <span class="title">
                        {{ $t('company.orderNumber.label') }}
                      </span>

                      <span class="col-12 col-md-7 value">
                        {{ company.orderNumber.label || $t('_undefined') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div id="max-price-per-room" class="col-12 section">
                  <p class="row">
                  <span class="col-12 col-md-5 title">
                    {{ $t('booking.maxPricePerRoom') }}
                  </span>

                  <span class="col-12 col-md-7 value">
                    {{ maxPricePerRoom }}
                  </span>
                  </p>
                </div>

                <!-- <div id="order-number" class="col-12 section" v-if="isManager && company.orderNumber"> -->

                <div id="payment-mode" class="col-12 section" v-if="isManager && company.paymentMode">
                  <p class="row">
                    <span class="col-12 col-md-5 title">
                      {{ $t('_payment_mode') }}
                    </span>

                    <span class="col-12 col-md-7 value">
                      {{ $t(`_payment_modes.${company.paymentMode}`) }}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="col-12 company-managers-section bg-light" v-if="company.managers">
                <div class="col-12 company-title">
                        <p class="row">
                          <span class="icon"><i class="fas fa-user-tie"></i></span>
                          <span class="ico-title">{{ $t('company.informations.managers') }}</span>

                        </p>
                      </div>
                <div class="col-12 company-managers-table">
                <table class="table table-striped">
                  <thead>
                    <th valign="top">{{ $t('_last_name') }}</th>
                    <th valign="top">{{ $t('_email') }}</th>
                    <th valign="top">{{ $t('_phone') }}</th>
                  </thead>
                  <tbody>
                    <tr v-for="manager in company.managers">
                      <td valign="top">{{manager.name}}</td>
                      <td valign="top">{{manager.email}}</td>
                      <td valign="top">
                        {{manager.landline}}<br>
                        {{manager.mobile}}
                      </td>
                     </tr>
                  </tbody>
                </table>
              </div>
              </div>
              <div class="users-management-section" v-if="isManager && !isPreloggedAllowed">
                <div class="row">
                  <div class="col-12 col-xl-6">
                    <div class="col-12 bg-light users-domain">
                      <div class="col-12 company-title">
                        <p class="row">
                          <span class="icon"><i class="fas fa-users"></i></span>
                          <span class="ico-title">{{ $t('company.informations.users') }}</span>
                        </p>
                      </div>
                      <div class="define-domain-section">
                        <div v-if="isManager && !isPreloggedAllowed" >
                          <div class="define-domain">
                            <table v-if="authorisedDomains.length" class="table table-striped">
                              <thead>
                                <th>{{ $t('home.profile.domains_management') }}</th>
                              </thead>
                              <tbody>
                                <tr v-for="domain in authorisedDomains" :key="domain.id">
                                  <td> {{ domain }} </td>
                                </tr>
                              </tbody>
                            </table>
                            <!-- <ul v-if="authorisedDomains.length">
                              <li v-for="domain in authorisedDomains" :key="domain.id">
                                {{ domain }}
                              </li>
                            </ul> -->
                            <p v-else class="message">
                              {{ $t('home.profile.no_domain') }}
                            </p>
                          </div>
                          <div class="define-domain-input">
                            <div class="row">
                            <b-input-group prepend="@" class="col-9">
                              <b-form-input id="inputModifPassword" v-model="newDomain" />
                            </b-input-group>

                            <span class="col-3 text-right add">
                              <button class=" orange-white btn" @click="addDomain">
                                {{ $t('_add') }}
                              </button>
                            </span>
                            </div>
                          </div>
                          <div class="col-lg-6 offset-lg-3">
                            <b-alert v-if="errors.domain" variant="danger" show>
                              <div class="error">
                                {{ errors.domain }}
                              </div>
                            </b-alert>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-xl-6">
                    <div class="col-12 bg-light users-manage-btn">
                      <div v-if="isManager" class="col-xl-6 users-access text-center">
                          <router-link :to="{ name: 'home_users' }" class="btn orange-white">
                            {{ $t('home.profile.users_management') }}
                          </router-link>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isManager || company.isPreloggedUrlDisplayable"
              class="unlogged-link"
              >
                <span>
                  {{ $t('home.profile.unlogged_url') }}
                </span>

                  <span>
                  <router-link :to="getUnloggedOfflineBookingRoute().routerLink">
                    {{ getUnloggedOfflineBookingRoute().href }}
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </frontoffice-frame>
</template>

<script>
import frontofficeFrame from '@/components/frontoffice/frame'
import CommonApi from '@/api/commonApi'
import pageTitle from '@/components/frontoffice/pageTitle'
import FormSubmitter from '@/api/formSubmitter'
import formatter from '@/components/global/mixins/formatterMethods'
import faBool from '@/components/frontoffice/faBool'
import imageInput from '@/components/frontoffice/form/customInput/image'
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    frontofficeFrame,
    pageTitle,
    faBool,
    imageInput,
    fa
  },

  mixins: [formatter],

  data () {
    return {
      commonApi: new CommonApi(),
      companyId: this.$route.params.id,
      company: null,
      user: null,
      isManager: false,
      isPreloggedAllowed: false,
      uniqueChain: null,
      groupAlias: null,
      authorisedDomains: [],
      newDomain: '',
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      errors: {
        password: [],
        domain: null,
        logo: null
      },
      success: {
        password: false,
        domain: false,
        logo: false
      },
      travelPolicy: {
        items: [],
        fields: [
          {
            key: 'sectorName',
            sortable: true,
            label: this.$t('_label')
          },
          {
            key: 'sectorType',
            sortable: true,
            label: this.$t('_type')
          },
          {
            key: 'room',
            sortable: true,
            label: this.$t('travelPolicy.price.room'),
            formatter: value => this.$options.filters.currency(value)
          },
          {
            key: 'evening',
            sortable: true,
            label: this.$t('travelPolicy.price.evening'),
            formatter: value => this.$options.filters.currency(value)
          },
          {
            key: 'meal',
            sortable: true,
            label: this.$t('travelPolicy.price.meal'),
            formatter: value => this.$options.filters.currency(value)
          },
          {
            key: 'no_breakfast',
            sortable: true,
            label: this.$t('travelPolicy.price.no_breakfast'),
            formatter: value => this.$options.filters.currency(value)
          }
        ]
      },
      logo: {
        fileTypes: '',
        file: null
      }
    }
  },

  created () {
    this.user = this.$store.getters['security/user']
    this.company = this.$store.getters['security/company']
    this.isManager = this.$store.getters['security/hasRole']('ROLE_MANAGER')
    this.logo.fileTypes = this.$store.getters['security/files']['companyLogo']['mime'].join()
    if (this.isManager || this.company.isPreloggedUrlDisplayable) {
      this.isPreloggedAllowed = this.company.isPreloggedAllowed
      this.uniqueChain = this.company.uniqueChain
      this.groupAlias = this.company.companyGroupAlias
      this.authorisedDomains = this.company.domains
    }
    this.setTravelPolicyTable()
  },

  methods: {
    reloadPage () {
      window.location.reload()
    },

    setLogo (file) {
      this.logo.file = file
    },

    sendLogo () {
      let submitter = new FormSubmitter('change_company_logo')
      let formData = new FormData()

      this.success.logo = false
      this.errors.logo = null

      formData.set('file', this.logo.file)
      submitter.submitRequest(formData)
        .then(response => {
          if (response.data.success) {
            this.dealSuccess('logo')
            this.$root.$emit('changeCompanyLogo', response.data.data.logo)
          } else {
            this.dealFailure('logo', this.$t(`error.${response.data.errors[0]}`))
          }
        })
    },

    setTravelPolicyTable () {
      let travelPolicy = this.company.travelPolicy
      if (!travelPolicy) return
      if (!travelPolicy.rows) return

      travelPolicy.rows.forEach(row => {
        this.travelPolicy.items.push({
          sectorName: row.sector ? row.sector.text : 'Valeurs par défaut',
          sectorType: row.sector ? row.sector.type : null,
          room: row.prices.room,
          evening: row.prices.evening,
          meal: row.prices.meal,
          no_breakfast: row.prices.no_breakfast
        })
      })
    },

    onSortTravelPolicy (a, b, sortBy, sortDesc) {
      // Always keep default values first
      if (sortDesc) {
        if (!a.sectorType) return 1
        if (!b.sectorType) return -1
      } else {
        if (!a.sectorType) return -1
        if (!b.sectorType) return 1
      }

      if (sortBy === 'sectorType') {
        let transA = this.$t(`sector.type.${a.sectorType}`)
        let transB = this.$t(`sector.type.${b.sectorType}`)

        return transA < transB ? -1 : transA > transB ? 1 : 0
      }
    },

    addDomain () {
      if (this.newDomain) {
        let submitter = new FormSubmitter('add_company_domain')
        submitter.submitRequest({ domain: this.newDomain })
          .then(response => {
            if (response.data.success) {
              let newDomain = response.data.data.new
              if (newDomain) this.authorisedDomains.push(newDomain)
              this.dealSuccess('domain')
            } else {
              this.dealFailure('domain', this.$t(`error.${response.data.errors[0]}`))
            }
          })
      }
    },

    toggleSendVoucherToTravellers (value) {
      this.commonApi.swapUserSendVoucherToTravellers()
      this.$store.commit('security/sendVoucherToTravellers', value)
    },

    getUnloggedOfflineBookingRoute () {
      if (this.isManager || this.company.isPreloggedUrlDisplayable) {
        let route = 'home_generic_company'
        let routeParams = {
          companyUid: this.uniqueChain
        }

        if (this.company.isPreloggedAllowed && this.groupAlias) {
          route = 'offline_booking_prelogged_group'
          routeParams = {
            groupAlias: this.groupAlias
          }
        }

        let routerLink = {
          name: route,
          params: routeParams
        }

        let href = ''

        if (window.location.origin) {
          href = window.location.origin
        } else {
          href = window.location.protocol + window.location.host
        }

        href += window.location.pathname + this.$router.resolve(routerLink).href

        return {
          routerLink: routerLink,
          href: href
        }
      }
    },

    changePassword () {
      let submitter = new FormSubmitter('change_password')
      this.errors.password = []
      submitter.submitRequest({
        'current': this.currentPassword,
        'new': this.newPassword,
        'new2': this.confirmNewPassword
      })
        .then(response => {
          if (response.data.success) {
            this.dealSuccess('password')
          } else {
            this.dealFailure('password', response.data.errors)
          }
        })
    },

    dealSuccess (type) {
      this.success[type] = true

      switch (type) {
        case 'password':
          this.errors.password = []
          this.currentPassword = ''
          this.newPassword = ''
          this.confirmNewPassword = ''
          break
        case 'domain':
          this.errors.domain = null
          this.newDomain = ''
          break
        case 'logo':
          this.errors.logo = null
          break
      }
    },

    dealFailure (type, error) {
      this.success[type] = false

      switch (type) {
        case 'password':
          for (let i in error) {
            if (error.hasOwnProperty(i)) {
              this.errors.password.push(this.$i18n.t('error.' + error[i]))
            }
          }
          break
        case 'domain':
          this.errors.domain = error
          break
        case 'logo':
          this.errors.logo = error
          break
      }
    },

    priceDisplay (value) {
      return value
        ? this.$options.filters.currency(value)
        : this.$t('_undefined')
    },

    formatManagersPhoneDisplay (landline, mobile) {
      if (!mobile && !landline) return null
      if (mobile && landline) return `${this.formatPhoneNumber(landline)} - ${this.formatPhoneNumber(mobile)}`
      return this.formatPhoneNumber(mobile || landline)
    },

    managerDetail (manager) {
      let ret = `${manager.name} : ${manager.email}`
      let phone = this.formatManagersPhoneDisplay(manager.landline, manager.mobile)
      if (phone) ret += ` - ${phone}`

      return ret
    }
  },

  computed: {
    maxPricePerRoom () {
      if (this.$store.getters['security/maxPricePerRoom']) { return this.$options.filters.currency(this.$store.getters['security/maxPricePerRoom']) } else return this.$t('_undefined')
    },

    displayTravelPolicy () {
      return ((this.company.travelPolicy && this.company.travelPolicy.mode) || this.company.mealPriceContribution)
    }
  }
}
</script>

<style lang="scss">
  .profile {
    .title::after {
      content: ' : '
    }

    .company-options {
      .section {
        margin: 1rem 0 1rem;
      }
    }

    .tp-row {
      margin: 1rem 0 1rem;
    }
  }
</style>
